/**
 * Mock treatment data for testing and development (Chinese display fields)
 */
export const mockTreatments = [
  // 基础项目
  {
    id: 'treat-1',
    name: '针灸疗法',
    description: '通过特定穴位的针刺刺激，调整身体平衡，治疗各种疼痛和功能性疾病。',
    type: 'basic',
    duration: 45,
    price: 380,
    practitioners: ['prac-1', 'prac-2'],
    isActive: true,
    tags: ['疼痛管理', '压力缓解', '神经调节'],
    applicableConditions: ['颈肩腰腿痛', '头痛', '失眠', '焦虑', '消化不良'],
    contraindications: ['出血性疾病', '严重心脏病', '孕妇特定穴位'],
    preparationInstructions: '治疗前避免饮用咖啡和酒精。',
    postTreatmentCare: '治疗后注意休息，避免剧烈运动。',
    image: null,
    createdAt: '2024-01-01T10:00:00.000Z',
    updatedAt: '2024-01-01T10:00:00.000Z',
    composedOf: []
  },
  {
    id: 'treat-2',
    name: '中药调理',
    description: '根据体质和症状定制中药汤剂，调理脏腑功能，改善体质。',
    type: 'basic',
    duration: 30,
    price: 420,
    practitioners: ['prac-3'],
    isActive: true,
    tags: ['体质调理', '慢性病管理', '脏腑调节'],
    applicableConditions: ['体质虚弱', '慢性疾病', '免疫力低下', '消化系统疾病'],
    contraindications: ['药物过敏', '严重肝肾功能不全'],
    preparationInstructions: '如有过敏请提前告知医生。',
    postTreatmentCare: '遵医嘱服药，注意不良反应。',
    image: null,
    createdAt: '2024-01-01T10:00:00.000Z',
    updatedAt: '2024-01-01T10:00:00.000Z',
    composedOf: []
  },
  {
    id: 'treat-3',
    name: '推拿按摩',
    description: '采用中医推拿手法，缓解肌肉紧张和关节不适，促进血液循环。',
    type: 'basic',
    duration: 60,
    price: 350,
    practitioners: ['prac-2', 'prac-4'],
    isActive: true,
    tags: ['肌肉放松', '关节保健', '血液循环'],
    applicableConditions: ['肌肉紧张', '关节活动受限', '疲劳综合征', '运动损伤'],
    contraindications: ['急性外伤', '骨折', '严重骨质疏松'],
    preparationInstructions: '建议穿宽松衣物。',
    postTreatmentCare: '按摩后多饮水，注意休息。',
    image: null,
    createdAt: '2024-01-01T10:00:00.000Z',
    updatedAt: '2024-01-01T10:00:00.000Z',
    composedOf: []
  },
  {
    id: 'treat-4',
    name: '艾灸疗法',
    description: '利用艾叶燃烧产生的温热刺激穴位，温阳补气，调理体质。',
    type: 'basic',
    duration: 40,
    price: 320,
    practitioners: ['prac-1', 'prac-5'],
    isActive: true,
    tags: ['温阳补气', '免疫调节', '慢性病调理'],
    applicableConditions: ['阳气不足', '免疫力低下', '慢性疲劳', '消化不良'],
    contraindications: ['发热', '阴虚火旺', '皮肤过敏'],
    preparationInstructions: '治疗前勿涂抹护肤品。',
    postTreatmentCare: '艾灸后注意保暖，避免受凉。',
    image: null,
    createdAt: '2024-01-01T10:00:00.000Z',
    updatedAt: '2024-01-01T10:00:00.000Z',
    composedOf: []
  },
  {
    id: 'treat-5',
    name: '拔罐疗法',
    description: '通过负压原理，促进局部血液循环，排除体内湿气和毒素。',
    type: 'basic',
    duration: 25,
    price: 280,
    practitioners: ['prac-2', 'prac-6'],
    isActive: true,
    tags: ['祛湿排毒', '血液循环', '肌肉放松'],
    applicableConditions: ['湿气重', '肌肉酸痛', '感冒初期', '血瘀证'],
    contraindications: ['皮肤破损', '出血性疾病', '孕妇'],
    preparationInstructions: '皮肤应保持清洁干燥。',
    postTreatmentCare: '拔罐后6小时内避免洗澡。',
    image: null,
    createdAt: '2024-01-01T10:00:00.000Z',
    updatedAt: '2024-01-01T10:00:00.000Z',
    composedOf: []
  },
  {
    id: 'treat-6',
    name: '刮痧疗法',
    description: '使用刮痧板在体表刮拭，促进微循环，排除病理代谢产物。',
    type: 'basic',
    duration: 30,
    price: 250,
    practitioners: ['prac-4', 'prac-5'],
    isActive: true,
    tags: ['排毒祛邪', '微循环', '免疫调节'],
    applicableConditions: ['感冒发热', '头痛', '肌肉酸痛', '血瘀证'],
    contraindications: ['皮肤病', '出血倾向', '过度虚弱'],
    preparationInstructions: '治疗前勿进食过饱。',
    postTreatmentCare: '刮痧后避免受风受凉。',
    image: null,
    createdAt: '2024-01-01T10:00:00.000Z',
    updatedAt: '2024-01-01T10:00:00.000Z',
    composedOf: []
  },
  // 特色调理项目
  {
    id: 'proj-1',
    name: '君子立本',
    description: '“君子立本”项目通过紫金古法秘方丹灸（传承400余年，深得道医全真龙门派第六代掌教真人赵真嵩怯湿排寒、扶阳固炁之精髓），结合熏灸督脉与足太阳膀胱经，深达脏腑，益气活血，化瘀去湿，温通经络，调和五脏，平衡阴阳，扶阳固本。配合通经络手法，帮助亚健康人群调理代谢失衡、免疫紊乱等问题，恢复健康，提升生命活力。',
    type: 'project',
    duration: 60,
    price: 880,
    practitioners: ['prac-1', 'prac-2', 'prac-5'],
    isActive: true,
    tags: ['特色项目', '亚健康', '扶阳固本'],
    applicableConditions: ['代谢失衡', '免疫紊乱', '湿寒淤堵', '睡眠质量差', '内分泌失调', '气血不足', '肝肾衰弱', '衰老加速', '五高', '结节频发'],
    contraindications: ['急性感染', '严重心脏病'],
    preparationInstructions: '治疗前避免饮用冷饮，保持心情平和。',
    postTreatmentCare: '遵医嘱调整生活方式，注意保暖，避免受凉。',
    image: null,
    createdAt: '2024-01-01T10:00:00.000Z',
    updatedAt: '2024-01-01T10:00:00.000Z',
    composedOf: ['treat-4', 'treat-3']
  },
  {
    id: 'proj-2',
    name: '雏英高飞',
    description: '“雏英高飞”项目通过白金古法秘方穴位灸、古法拨筋通经络，帮助青少年调理脾胃、强身增高。采用秘制灸贴精准贴敷渗透，古法拨筋导引术开筋活络，延缓骨骺闭合，促进脾胃运化，助力身体自然长高。药食同源辅助加能，安全、无毒、绿色、自然，多管齐下，1次有感，3天改善，1月可见增高，普遍体质增强、稳步自然长高。',
    type: 'project',
    duration: 55,
    price: 980,
    practitioners: ['prac-2', 'prac-4', 'prac-5'],
    isActive: true,
    tags: ['特色项目', '青少年', '增高'],
    applicableConditions: ['身高偏低', '脾胃虚弱', '食欲不振', '体质虚弱（5-18岁）', '挑食厌食', '长高迟缓或停滞'],
    contraindications: ['严重过敏', '急性疾病'],
    preparationInstructions: '治疗前请先测量身高，保持空腹2小时。',
    postTreatmentCare: '建议均衡饮食，规律锻炼，注意休息。',
    image: null,
    createdAt: '2024-01-01T10:00:00.000Z',
    updatedAt: '2024-01-01T10:00:00.000Z',
    composedOf: ['treat-4', 'treat-3', 'treat-6']
  },
  {
    id: 'proj-3',
    name: '古法调理',
    description: '“古法调理”项目以中华瑰宝白金古法秘方穴位灸为核心，配合秘制灸贴精准贴敷渗透，古法拨筋导引术开筋活络，延缓骨骺闭合，促进脾胃运化，助力身体自然长高。药食同源辅助加能，安全、无毒、绿色、自然，多管齐下，1次有感，3天改善，1月可见增高，普遍体质增强、稳步自然长高。',
    type: 'project',
    duration: 60,
    price: 1080,
    practitioners: ['prac-2', 'prac-4', 'prac-5'],
    isActive: true,
    tags: ['特色项目', '古法', '体质增强', '增高'],
    applicableConditions: ['身高偏低', '体质虚弱', '脾胃不和', '骨骺早闭风险', '免疫力低下'],
    contraindications: ['严重皮肤病', '急性传染病'],
    preparationInstructions: '治疗前保持皮肤清洁，避免进食过饱。',
    postTreatmentCare: '调理后注意休息，避免剧烈运动，保持良好作息。',
    image: null,
    createdAt: '2024-01-01T10:00:00.000Z',
    updatedAt: '2024-01-01T10:00:00.000Z',
    composedOf: ['treat-4', 'treat-3', 'treat-6']
  }
];

export default mockTreatments; 